import ApiConnector from "../connector";

class EventsActions {
  get = async (params) => {
    const result = {
      value: false,
      error: null,
    };

    try {
      const response = await ApiConnector.connector.get(`/event-logs/`, { params });
      result.value = response.data;
    } catch (e) {
      result.error = e.response.data.fallback_message;
    }

    return result;
  };
  getOne = async (id) => {
    const result = {
      value: false,
      error: null,
    };

    try {
      const response = await ApiConnector.connector.get(`/event-logs/${id}/`);
      result.value = response.data;
    } catch (e) {
      result.error = e.response.data.fallback_message;
    }

    return result;
  };
  create = async (event) => {
    const result = {
      value: false,
      error: null,
    };

    try {
      const response = await ApiConnector.connector.post(`/event-logs/`, event);
      result.value = response.data;
    } catch (e) {
      result.error = e.response.data;
    }

    return result;
  };
  update = async (event) => {
    const result = {
      value: false,
      error: null,
    };

    try {
      const response = await ApiConnector.connector.patch(`/event-logs/${event.id}/`, event);
      result.value = response.data;
    } catch (e) {
      result.error = e.response.data;
    }

    return result;
  };
  delete = async (id) => {
    const result = {
      value: false,
      error: null,
    };

    try {
      const response = await ApiConnector.connector.delete(`/event-logs/${id}/`);
      result.value = response.data;
    } catch (e) {
      result.error = e.response.data.fallback_message;
    }

    return result;
  };
}

export default new EventsActions();
